import { combineReducers } from 'redux';

import caseTypeReport from './casetypereport/reducer';

export default combineReducers({
  caseTypeReport,
});



// WEBPACK FOOTER //
// ./src/pages/casetype/state/reducer.js